import script from "./resetPwd.vue?vue&type=script&setup=true&lang=ts"
export * from "./resetPwd.vue?vue&type=script&setup=true&lang=ts"

import "./resetPwd.vue?vue&type=style&index=0&id=4728e93c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4728e93c"]])

export default __exports__